<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar branded">
            <div class="left">
                <a v-on:click="$router.go(-1)">
                    <svg class="icon icon-back" aria-hidden="true"></svg>
                </a>
            </div>
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="right">
                &nbsp;
            </div>
        </ons-toolbar>

        <div class="content">
            <v-ons-progress-bar v-if="show_loading" indeterminate class="fixed"/>
        </div>

        <v-ons-alert-dialog
            data-test-id="dlg-order-exists-loading"
            v-bind:visible="check_exists_loading">
            <section class="section-vh">
                <div class="loading-container">
                    <span>{{ loading_message }}</span>
                    <v-ons-progress-circular indeterminate class="loading-spinner"/>
                </div>
            </section>
        </v-ons-alert-dialog>

    </v-ons-page>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: "processing",

    props: [],

    data() {
        return {
            app: this.$root.$data.app,
            check_exists_loading: false,
            loading_message: 'Checking in-progress order status...',
            request_attempt: 0,
        }
    },

    mounted() {

        this.show_loading_message = true

        setTimeout(this.beginOrderExists, 1000)
    },

    methods: {

        ...mapMutations([
            'clearOrder',
            'setCheckoutInProgress',
        ]),

        async beginOrderExists() {

            this.check_exists_loading = true

            try {
                const response = await this.orderExistsRequest()
                this.clearOrder()
                this.app.redirectToOrder(response.data, { in_flight: true })
                return Promise.resolve(null)
            } catch (error) {

                // No response received, need to retry
                if (this.app.errorIsHttpWithoutResponse(error)) {

                    // Reached max attempts, stop until the user clicks the retry button in this dialog
                    if (this.app.maxRetryAttemptsReached(this.request_attempt)) {
                        this.check_exists_loading = false
                        const attempts_exhausted_message = 'We were unable to check whether your previous order was ' +
                            'created due to a network connection issue. Please check your network connection, then ' +
                            'click the retry button.'
                        await this.$ons.notification.alert(
                            attempts_exhausted_message,
                            {
                                title: 'Unable to check order status',
                                buttonLabel: 'Retry',
                            }
                        )
                    }

                    this.check_exists_loading = true
                    return await this.beginOrderExists()
                }
                // Response received, handle expected errors
                else {

                    this.check_exists_loading = false

                    // Does not exist, continue to checkout page
                    if (error.response.status == 404) {
                        this.setCheckoutInProgress(false)
                        this.$router.replace({
                            name: 'CreateOrder',
                            params: {
                                outlet_slug: this.order.outlet_slug,
                                in_flight: true,
                            }
                        })
                    }
                    // Unexpected error
                    else {
                        // Clear the order so that the user doesn't get stuck here forever
                        this.app.logException(
                            new Error('Error occurred checking in-progress order status.'),
                            { error }
                        )

                        const message = 'An error occurred while checking the status of your in-progress order. You can' +
                            ' check your recent orders page to check the status.'
                        await this.$ons.notification.alert(message, { title: 'Unable to check order status' })

                        this.clearOrder()
                        this.$router.replace(this.app.homeRoute())
                    }

                    return Promise.resolve(null)
                }
            }
        },

        async orderExistsRequest() {

            if (this.request_attempt > 1) {
                const network_message = 'A network error has occurred - we\'re retrying'
                this.loading_message = network_message

                await new Promise(resolve => setTimeout(resolve, this.app.networkRetryDelay()))
            }

            this.request_attempt += 1
            return this.app.http.get(
                `order/exists/${this.order.local_id}`,
                {},
                { headers: { 'Request-Attempt': this.request_attempt }},
            )
        },
    },

    computed: {

        ...mapGetters(['order']),

        show_loading() {
            return this.check_exists_loading
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/order/processing.vue